import Vue from "vue";
import * as api from "~/api/resource";

export const state = {
    ScheduleTrip: null,
    drivers: [],
    vehicles: [],
    selections: {},
};

export const getters = {
    ScheduleTrip: state => state.ScheduleTrip,
    drivers: state => state.drivers,
    vehicles: state => state.vehicles,
    columns: state => state.columns,
    search: state => state.search,

    total: state => state.total,
    list: state =>
        state.list ? state.list.map(id => state.entities[id.toString()]) : [],

    byId: state => id => state.entities[_.toString(id)]
};

export const mutations = {
    setScheduleTrip(state, payload) {
        state.ScheduleTrip = payload.ScheduleTrip; // list.map(m => m['id'].toString());
    },
    toggleSelection(state, payload) {
        if (!state.selections[payload.context]) {
            state.selections[payload.context] = {}
            state.selections[payload.context][payload._sk] = payload.data
            return
        }
        if (!state.selections[payload.context][payload._sk]) state.selections[payload.context][payload._sk] = payload.data
        else delete state.selections[payload.context][payload._sk]
        // state.selections[payload.context] = payload.data; // list.map(m => m['id'].toString());
    },
    setList(state, payload) {
        state[payload.context] = payload.list; // list.map(m => m['id'].toString());
    },
    setSingle(state, data) {
        // const obj = Object.assign({}, state.entities[data['id'].toString()], data)
        const obj = _.merge({}, state.entities[data["id"].toString()], data);
        Vue.set(state.entities, data["id"].toString(), obj);
    }
};

export const actions = {
    fetchList({commit}, payload) {
        var lists = {
            drivers: {type: "contacts", contactTypes: "driver", sort: "name"},
            vehicles: {type: "assets", sort: "name"}
        };
        for (const key in lists) {
            if (lists.hasOwnProperty(key)) {
                var qoptions = lists[key];
                qoptions.limit = 0;
                const t = qoptions.type;
                delete qoptions.type;
                api.fetchList(t, qoptions)
                   .then(({data}) => {
                       commit("setList", {context: key, list: data.results});
                   });
            }
        }
    },
    fetchScheduleTrip({commit}, payload) {
        // try {
        //     this.ScheduleTrip = await api.fetchObject("ScheduleTrip", {
        //       id: changed.params.tripid,
        //       with: "TripService"
        //     });
        //   } catch (error) {
        //     alert("error loading ScheduleTrip:" + id);
        //   }
        return api
            .fetchObject("scheduletrip", {
                id: payload,
                with: "TripService"
            })
            .then(({data}) => {
                commit("setScheduleTrip", data.object);
            });
    },
    fetchSingle({commit}, payload) {
        return api.fetchObject(state.type, payload)
                  .then(({data}) => {
                      commit("setSingle", data.object);
                  });
    }
};
